import React, {useEffect, useRef, useState} from 'react';
import {Carousel} from 'antd';
import {collection, getDocs, limit, orderBy, query} from 'firebase/firestore';
import {db} from '../config/firebase';
import {useLanguage} from '../contexts/LanguageContext';
import dayjs from 'dayjs';
import {CaseItem} from "../types/CardItems";
import {Link} from "react-router-dom";

const CustomerWitness: React.FC = () => {
    const [cases, setCases] = useState<CaseItem[]>([]);
    const [loading, setLoading] = useState(true);
    const lastDocRef = useRef<any>(null);
    const {currentLang} = useLanguage();

    const fetchCases = async () => {
        try {
            const q = query(
                collection(db, 'cases'),
                orderBy('showTime', 'desc'),
                limit(10)
            );

            const querySnapshot = await getDocs(q);
            const newCases: CaseItem[] = [];

            querySnapshot.forEach((doc) => {
                newCases.push({id: doc.id, ...doc.data()} as CaseItem);
            });

            if (querySnapshot.docs.length > 0) {
                lastDocRef.current = querySnapshot.docs[querySnapshot.docs.length - 1];
            }

            setCases(newCases);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching cases:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCases();
    }, []);

    if (loading || cases.length === 0) {
        return <div className="flex justify-center items-center h-96">Loading...</div>;
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* 标题区域 */}
            <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-center mb-16">
                    {currentLang === 'zh' ? '客户见证' : 'Customer Witness'}
                </h2>
            </div>

            {/* 轮播区域 */}
            <Carousel
                autoplay
                autoplaySpeed={3000}
                dots={true}
                className="mb-8"
            >
                {cases.map((item) => (
                    <div key={item.id}>
                        <Link to={`/${currentLang}/cases`} className='cursor-pointer'>
                            <div className="relative h-[500px] overflow-hidden">
                                <img
                                    src={item.images[0]}
                                    alt={item.title[currentLang]}
                                    className="w-full object-cover"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-6">
                                    <h3 className="text-xl font-bold mb-2">
                                        {item.title[currentLang]}
                                    </h3>
                                    <p className="text-sm">
                                        {dayjs(item.showTime).format('YYYY-MM-DD')}
                                    </p>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default CustomerWitness;
